
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product",
      function () {
        return require("private-next-pages/product.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product"])
      });
    }
  